import { NgClass, NgOptimizedImage } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    ElementRef,
    inject,
    input,
    viewChild,
    ViewEncapsulation,
} from '@angular/core';
import { AssetPipe } from '@libraries/asset/asset.pipe';
import { ImageUrlPipe } from '@shared/image-url/image-url.pipe';
import { ResizeService } from '@shared/resize/resize.service';
import { tap } from 'rxjs';
import { FramePipe } from '../frame/frame.pipe';
import { ShowCase } from '../show-cases.type';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'jsdaddy-image-with-frame[showCase]',
    standalone: true,
    imports: [FramePipe, AssetPipe, ImageUrlPipe, NgOptimizedImage, NgClass],
    templateUrl: './image-with-frame.component.html',
    styleUrl: './image-with-frame.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageWithFrameComponent implements AfterViewInit {
    public showCase = input.required<ShowCase | undefined>();

    public image = input<number>();

    public half = input(false);

    public readonly imageRef = viewChild<string, ElementRef<HTMLElement>>('imageRef', {
        read: ElementRef,
    });

    private readonly cdr = inject(ChangeDetectorRef);

    private readonly resizeService = inject(ResizeService);

    private readonly destroyRef = inject(DestroyRef);

    public height = 0;

    public ngAfterViewInit(): void {
        if (this.half()) {
            this.resizeService
                .createResizeSequence(this.imageRef()?.nativeElement)
                .pipe(
                    tap((width) => {
                        if (!this.showCase()) {
                            return;
                        }
                        switch (this.showCase()?.type) {
                            case 'mobile':
                                this.height = width;
                                break;
                            case 'web':
                                this.height = width * 0.3;
                                break;
                            case 'landscape-tablet':
                                this.height = width * 0.375;
                                break;
                            case 'portrait-tablet':
                                this.height = width * 0.65;
                                break;
                        }
                        this.cdr.detectChanges();
                    }),
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe();
        }
    }
}
